import React from 'react'
import { storiesOf } from '@storybook/react'

import CheckoutDialog from 'components/CheckoutDialog'
import { StorePremiumProduct } from 'protos'

const product = StorePremiumProduct.create({
  productId: 'com.something.product',
})

storiesOf('CheckoutDialog', module)
  .add('default', () => (
    <CheckoutDialog product={product} open />
  ))
